import {
  MaterialReactTable,
  type MRT_RowData,
  type MRT_TableOptions,
  useMaterialReactTable,
} from "material-react-table";

type MRTNoMemoProps<TData extends MRT_RowData> = {
  options?: MRT_TableOptions<TData>;
};

export function MRTNoMemo<TData extends MRT_RowData>(props: Readonly<MRTNoMemoProps<TData>>) {
  "use no memo";

  const baseOptions = props.options ?? ({} as MRT_TableOptions<TData>);
  const baseTable = useMaterialReactTable<TData>(baseOptions);

  return <MaterialReactTable table={baseTable} />;
}
